import {
    ADD_SERVICE_TYPE_FAIL,
    ADD_SERVICE_TYPE_SUCCESS,
    DELETE_SERVICE_TYPE_FAIL,
    DELETE_SERVICE_TYPE_SUCCESS,
    BULK_DELETE_SERVICE_TYPE_FAIL,
    BULK_DELETE_SERVICE_TYPE_SUCCESS,
    EXPORT_SERVICE_TYPE_FAIL,
    EXPORT_SERVICE_TYPE_SUCCESS,
    GET_SERVICE_TYPE_DETAILS_FAIL,
    GET_SERVICE_TYPE_DETAILS_SUCCESS,
    GET_SERVICE_TYPE_LISTING_FAIL,
    GET_SERVICE_TYPE_LISTING_SUCCESS,
    RESET_SERVICE_TYPE_ATTACHMENT_STATE,
    RESET_SERVICE_TYPE_STATE,
    UPDATE_SERVICE_TYPE_FAIL,
    UPDATE_SERVICE_TYPE_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    serviceTypeListing: [],
    serviceTypeDetails: [],
    addServiceType: [],
    updateServiceType: [],
    deleteServiceType: [],
    bulkDeleteServiceType: [],
    exportServiceType: [],
    error: [],
}

const ServiceType = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SERVICE_TYPE_LISTING_SUCCESS:
            return {
                ...state,
                serviceTypeListing: action.payload
            }
        case GET_SERVICE_TYPE_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SERVICE_TYPE_DETAILS_SUCCESS:
            return {
                ...state,
                serviceTypeDetails: action.payload
            }
        case GET_SERVICE_TYPE_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_SERVICE_TYPE_SUCCESS:
            return {
                ...state,
                addServiceType: action.payload
            }
        case ADD_SERVICE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_SERVICE_TYPE_SUCCESS:
            return {
                ...state,
                updateServiceType: action.payload
            }
        case UPDATE_SERVICE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_SERVICE_TYPE_SUCCESS:
            return {
                ...state,
                deleteServiceType: action.payload
            }
        case DELETE_SERVICE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case BULK_DELETE_SERVICE_TYPE_SUCCESS:
            return {
                ...state,
                bulkDeleteServiceType: action.payload
            }
        case BULK_DELETE_SERVICE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_SERVICE_TYPE_SUCCESS:
            return {
                ...state,
                exportServiceType: action.payload
            }
        case EXPORT_SERVICE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_SERVICE_TYPE_STATE:
            return {
                ...state,
                serviceTypeListing: [],
                serviceTypeDetails: [],
                addServiceType: [],
                updateServiceType: [],
                deleteServiceType: [],
                bulkDeleteServiceType: [],
                exportServiceType: [],
                error: [],
            }
        case RESET_SERVICE_TYPE_ATTACHMENT_STATE:
            return {
                ...state,
                exportServiceType: [],
                error: [],
            }
        default:
            return state
    }
}

export default ServiceType
